import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BookingObjectService } from '@services/booking-object.service';
import { CostaBackendApiService } from '@services/costa-backend-api.service';
import { ErrorMessagesService } from '@services/error-messages.service';
import { LoadingService } from '@services/loading.service';
import { MarketService } from '@services/market.service';
import { PostBookingFlowService } from '@services/post-booking-flow.service';
import { parseSearch } from '@utils/Navigation/parseSearch.utils';
import { redirectTo } from '@utils/Navigation/redirectTo.utils';
import { BookingSearch } from '@values/Booking/BookingSearch.value';
import { PagePaths } from '@values/Navigation/PagePaths.value';
import { BookingFlowServicesService } from '@services/api/booking-flow-services.service';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class AbstractBasePaymentManagerComponent implements OnInit {
  protected readonly _loadingService = inject(LoadingService);
  protected readonly _marketService = inject(MarketService);
  protected readonly _postBookingFlowService = inject(PostBookingFlowService);
  protected readonly _bookingObjectService = inject(BookingObjectService);
  protected readonly _costaBackendApiService = inject(CostaBackendApiService);
  protected readonly _errorMessagesService = inject(ErrorMessagesService);
  protected readonly _bookingFlowServicesService = inject(BookingFlowServicesService);
  protected readonly _translateService = inject(TranslateService);

  public isLoading = true;

  protected params;

  public get hasWorldPayRedirect() {
    return this._marketService.hasWorldPayRedirect();
  }

  ngOnInit() {
    this._loadingService.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading) => {
      this.isLoading = isLoading;
    });

    this.params = parseSearch();

    if (!this.hasWorldPayRedirect && this.params['paymentStatus'] === 'AUTHORISED') {
      this._loadingService.startLoading('PaymentManagerCtrl_displayBooking');
      this._postBookingFlowService.displayBooking(
        this.onDisplayBookingSuccess.bind(this),
        this.onDisplayBookingFailure.bind(this),
        this.params.bookingNumber,
        '',
      );
    }
  }

  private goToBookingEditPage() {
    const bookingNumber = this._bookingObjectService.getBookingNumber();
    redirectTo(`${PagePaths.bookingEdit}?${BookingSearch.paramBooking}=${bookingNumber}`);
  }

  private onDisplayBookingSuccess() {
    const currentBookingObject = this._bookingObjectService.getCurrentBookingObject();

    let amount = undefined;

    if (this.params.paymentType == 'DEPOSIT') {
      if (currentBookingObject.PaymentInfo.PaymentDetails.DepositInvoiceAmount > 0) {
        amount = currentBookingObject.PaymentInfo.PaymentDetails.DepositInvoiceAmount;
      }
    } else {
      if (currentBookingObject.PaymentInfo.PaymentDetails.DueAmount > 0) {
        amount = currentBookingObject.PaymentInfo.PaymentDetails.DueAmount;
      }
    }

    if (amount) {
      const paymentObj = {
        Amount: amount,
        CreditCardToken: {
          Id: this.params.orderKey,
        },
      };

      this._costaBackendApiService
        .modifyBooking(currentBookingObject, paymentObj)
        .then(() => {
          this.goToBookingEditPage();
        })
        .catch((err) => {
          this._loadingService.stopLoading('PaymentManagerCtrl_displayBooking');
          this._errorMessagesService.showErrorAlert(err.message);
        });
    } else {
      this.goToBookingEditPage();
    }
  }

  private onDisplayBookingFailure() {
    this._loadingService.stopLoading('PaymentManagerCtrl_displayBooking');
    this._errorMessagesService.showErrorAlert('errore');
  }
}
